import * as actionTypes from '../actions/Actions'

export const setMode = () => ({ type: actionTypes.SET_MODE });
